import React, { useState } from "react";
import "./App.css";
import ErrorBoundary from "./components/common/errorBoundaryComponent/ErrorBoundaryComponent";
import { IntlProvider } from "react-intl";
import NotificationSnack from "./components/common/notificationSnackComponent/NotificationSnackComponent";
import GlobalLoadingComponent from "./components/common/loading/GlobalLoadingComponent";

import { createTheme, ThemeProvider } from "@mui/material";
import { orange } from "@mui/material/colors";

import Routes from "./components/routes/Routers";

import messagesEs from "./translations/es.json";
import messagesEn from "./translations/en.json";
import messagesGl from "./translations/gl.json";
import { COMMON__ERROR_404 } from "./translations/constans";
import {
  ASTERISK,
  BACK_SLASH,
  BLUE_049FE3,
  CLASSNAME_APP,
  LANDING_ERROR_BOUNDARY,
  LANGUAGES_ES,
} from "./utils/constants";
import { language } from "./utils/utils";

const theme = createTheme({
  palette: {
    primary: {
      main: BLUE_049FE3,
    },
    secondary: orange,
  },
});

const messages = {
  es: messagesEs,
  en: messagesEn,
  gl: messagesGl,
};

const App = () => {
  const [locale] = useState({ locale: language, messages: messages[language] });

  return (
    <IntlProvider
      defaultLocale={LANGUAGES_ES}
      locale={locale.locale}
      messages={locale.messages}
    >
      <ThemeProvider theme={theme}>
        <div className={CLASSNAME_APP}>
          <ErrorBoundary key={LANDING_ERROR_BOUNDARY}>
            <Routes />
          </ErrorBoundary>
          <NotificationSnack />
          <GlobalLoadingComponent />
        </div>
      </ThemeProvider>
    </IntlProvider>
  );
};

export default App;
